import React, { useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import NewsletterConsent from "./Layout/newsletterConsent";
import NewsletterAddtionalInfo from "./newsletterAdditionalInfo";

const NewsletterFooterDiv = styled.div`
  background-image: linear-gradient(103deg, #010306, #083976 100%);
  padding: 50px 0;
  color: #ffffff;
  &.h4 {
    color: #ffffff;
  }
`;

const TextDiv = styled.div`
  padding-right: 130px;
  @media (max-width: 726px) {
    padding-right: 0px;
  }
`;

const Heading = styled.h4`
  color: #ffffff;
  line-height: 1.33;
  margin-bottom: 20px;
`;

const SubHeading = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.125rem;
  line-height: 1.56;
`;

const NewsletterFooter = () => {
  const [emailError, setEmailError] = useState();
  const [newsletterChecked, setNewsletterChecked] = useState(true);
  const [updatesChecked, setUpdatesChecked] = useState(true);
  const [emailInput, setEmailInput] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [showAdditionalInfo, setShowAddiitonalInfo] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [complete, setComplete] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleInputChange = (value, key) => {
    if (key === "email") {
      setEmailInput(value);
      setEmailError();
    }
    if (key === "firstName") {
      setFirstName(value);
      setSubmitError(null);
    }
    if (key === "lastName") {
      setLastName(value);
      setSubmitError(null);
    }
    if (key === "company") {
      setCompany(value);
      setSubmitError(null);
    }
    if (key === "newsletter") {
      setNewsletterChecked(value);
    }
    if (key === "updates") {
      setUpdatesChecked(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!emailInput) {
      if (!emailInput) setEmailError("This field is required.");
      return;
    }
    if (!validateEmail(emailInput)) {
      setEmailError("This must be a valid email address");
      return;
    }
    if (
      showAdditionalInfo
        ? firstName || lastname || company
        : newsletterChecked || updatesChecked
    ) {
      const result = await addToMailchimp(emailInput, {
        NEWSLETTER: newsletterChecked ? "Yes" : "No",
        INSIGHTS: updatesChecked ? "Yes" : "No",
        FNAME: firstName,
        LNAME: lastname,
        MMERGE6: company,
      });
      if (result.result === "success") {
        setSubmitError(null);
        if (showAdditionalInfo) {
          setComplete(true);
        } else {
          setShowAddiitonalInfo(true);
        }
      } else {
        const genericMessage = "Something went wrong, please try again";
        setSubmitError(result.msg || genericMessage);
      }
    } else {
      setSubmitError(
        showAdditionalInfo
          ? "Please fill in at least one field"
          : "You must agree to at least one checkbox"
      );
    }
  };

  return (
    <NewsletterFooterDiv>
      <Container>
        <Row>
          <Col lg={6} md={12}>
            <TextDiv>
              <Heading>Join the TrustFlight newsletter</Heading>
              <SubHeading>
                Stay informed of aviation technology developments that could
                impact your operations.
              </SubHeading>
            </TextDiv>
          </Col>

          <Col lg={6} md={12}>
            {showAdditionalInfo ? (
              <NewsletterAddtionalInfo
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                submitError={submitError}
                secondary
                finishedForm={complete}
              />
            ) : (
              <NewsletterConsent
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                submitError={submitError}
                newsletterChecked={newsletterChecked}
                updatesChecked={updatesChecked}
                emailError={emailError}
                secondary
              />
            )}
          </Col>
        </Row>
      </Container>
    </NewsletterFooterDiv>
  );
};

export default NewsletterFooter;
